module.exports = __webpack_public_path__ + "static/media/back.88552390.svg";